import { cn } from '@arcsite/utils';

interface PulseRippleProps {
  centerColor?: string;
  rippleColor?: string;
  size?: 'small' | 'medium' | 'large';
  duration?: number;
  animate?: boolean;
  className?: string;
}

const PulseRipple: React.FC<PulseRippleProps> = ({
  centerColor = 'bg-blue-500',
  rippleColor = 'bg-blue-300',
  size = 'medium',
  animate = true,
  className,
}) => {
  const sizeConfig = {
    small: {
      container: 'w-4 h-4',
      center: 'w-2 h-2',
      ripple: 'w-4 h-4',
    },
    medium: {
      container: 'w-6 h-6',
      center: 'w-3 h-3',
      ripple: 'w-6 h-6',
    },
    large: {
      container: 'w-8 h-8',
      center: 'w-4 h-4',
      ripple: 'w-8 h-8',
    },
  };

  const config = sizeConfig[size];

  return (
    <div
      className={cn(
        'relative flex items-center justify-center',
        config.container,
        className
      )}
    >
      {animate && (
        <div
          className={cn(
            'absolute rounded-full opacity-75 animate-pulse-ripple',
            config.ripple,
            rippleColor
          )}
        />
      )}

      <div
        className={cn('relative rounded-full z-10', config.center, centerColor)}
      />
    </div>
  );
};

export default PulseRipple;
